import { PropsWithChildren } from 'react'
import { Footer } from '../../components/footer'
import { NavigationBar } from '../../components/navigation-bar'
import { NavigationBarStub } from '../../components/navigation-bar-stub'
import * as styles from './with-layout.css.ts'

export const WithLayout = (props: PropsWithChildren) => {
  return (
    <>
      <NavigationBar />
      <div className={styles.siteContainer}>
        <main className={styles.main}>{props.children}</main>
        <Footer />
      </div>
    </>
  )
}

export const WithStubLayout = (props: PropsWithChildren) => {
  return (
    <>
      <NavigationBarStub />
      <div className={styles.siteContainer}>
        <main className={styles.main}>{props.children}</main>
        <Footer />
      </div>
    </>
  )
}
